import React from 'react';
import { CheckCircleIcon, TruckIcon, AwardIcon, StarIcon, ShieldIcon } from 'lucide-react';
interface RecommendedDealerProps {
  vendor: {
    id: string;
    name: string;
    rating: number;
    price: number;
    originalPrice: number;
    condition: string;
    deliveryTime: string;
    inStock: boolean;
  };
}
export const RecommendedDealer = ({
  vendor
}: RecommendedDealerProps) => {
  return <div className="border-2 border-blue-500 rounded-lg p-6 bg-blue-50 hover:shadow-lg transition-shadow relative mb-6" data-id="element-1217">
      <div className="absolute -top-3 left-4 bg-blue-600 text-white px-4 py-1 rounded-full text-sm font-bold" data-id="element-1218">
        Recommended Dealer
      </div>
      <div className="flex justify-between" data-id="element-1219">
        <div data-id="element-1220">
          <div className="flex items-center" data-id="element-1221">
            <h4 className="font-bold text-xl" data-id="element-1222">{vendor.name}</h4>
            <AwardIcon className="h-5 w-5 text-yellow-500 ml-2" data-id="element-1223" />
          </div>
          <div className="flex items-center mt-2" data-id="element-1224">
            <div className="flex" data-id="element-1225">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className={`h-4 w-4 ${i < Math.floor(vendor.rating) ? 'text-yellow-400' : 'text-gray-300'}`} fill={i < Math.floor(vendor.rating) ? 'currentColor' : 'none'} data-id="element-1226" />)}
            </div>
            <span className="ml-2 text-sm font-medium" data-id="element-1227">
              {vendor.rating}/5.0
            </span>
            <div className="ml-3 flex items-center text-sm text-green-700" data-id="element-1228">
              <CheckCircleIcon className="h-4 w-4 mr-1" data-id="element-1229" />
              <span data-id="element-1230">Top Rated Seller</span>
            </div>
          </div>
          <div className="mt-3 flex flex-col gap-1" data-id="element-1231">
            <div className="flex items-center text-sm" data-id="element-1232">
              <TruckIcon className="h-4 w-4 text-blue-600 mr-2" data-id="element-1233" />
              <span className="font-medium" data-id="element-1234">
                Express Delivery in {vendor.deliveryTime}
              </span>
            </div>
            <div className="flex items-center text-sm" data-id="element-1235">
              <ShieldIcon className="h-4 w-4 text-blue-600 mr-2" data-id="element-1236" />
              <span data-id="element-1237">Extended 6-month warranty</span>
            </div>
            <div className="flex items-center text-sm" data-id="element-1238">
              <CheckCircleIcon className="h-4 w-4 text-blue-600 mr-2" data-id="element-1239" />
              <span data-id="element-1240">100% authentic device guarantee</span>
            </div>
          </div>
        </div>
        <div className="flex flex-col items-end justify-between" data-id="element-1241">
          <div data-id="element-1242">
            <div className="text-3xl font-bold text-gray-900" data-id="element-1243">
              ${vendor.price}
              <span className="text-sm align-top" data-id="element-1244">.00</span>
            </div>
            <div className="text-sm text-gray-500 line-through" data-id="element-1245">
              ${vendor.originalPrice}.00
            </div>
            <div className="bg-green-100 text-green-700 text-xs font-bold px-2 py-1 rounded-full mt-1 inline-block" data-id="element-1246">
              Save ${vendor.originalPrice - vendor.price}
            </div>
          </div>
          <button className="mt-4 bg-blue-600 text-white px-8 py-3 rounded-md hover:bg-blue-700 transition-colors font-medium" data-id="element-1247">
            Add to Cart
          </button>
        </div>
      </div>
    </div>;
};